<div id="contenedor-svg">
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="2000" viewBox="0 0 1512 982" fill="none"></svg>
    <div class="svg-texto">
        <img src="assets/img/card-error.png" alt="" class="">
        <p class="error-text">{{ errorMessage }}</p>
    </div>
    <div class="textMessage text-center">
        {{ textMessage }}
        <ul class="text-left suggestion pt-2">
            <li *ngFor="let suggestion of suggestions">
                {{ suggestion }}
            </li>
        </ul>
        <button class="form__button" routerLink="/dashboard"> Volver al inicio</button>
    </div>
</div>